import type {PropsWithChildren} from 'react';
import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import styles from './overview.module.css';

type Props = PropsWithChildren;

export function CompanyInformationOverview({children}: Props) {
  return (
    <div
      className={clsx(
        styles.overview,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
    >
      {children}
    </div>
  );
}
